/* eslint-disable camelcase */
import React, { useMemo } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { FiPlus } from "react-icons/fi";
import useWindowResize from "hooks/useWindowResize.ts";
import { getJobsMaximum } from "store/modules/users/selectors";
import JobCreateButton from "components/Common/Button/JobCreateButton.tsx";
import fingerprintImg from "../../assets/images/landing/fingerprint.png";
import sunImg from "../../assets/images/landing/sun.png";
import waveImg from "../../assets/images/landing/wave.png";

const EmptyStateHeader = ({
  handleCreateJob,
  profile
}: {
  handleCreateJob: () => void;
  profile: {
    full_name: string
  };
  onboarding: {
    agency_jobs_amount: number;
  };
  maximumJobs: number;
}) => {
  const { t } = useTranslation();
  const { isMobileScreen } = useWindowResize();

  const greeting = useMemo(() => {
    const currentTime = new Date().getHours();

    if (currentTime >= 5 && currentTime < 12) {
      return "Good Morning";
    }

    if (currentTime >= 12 && currentTime < 17) {
      return "Good Afternoon";
    }

    return "Good Evening";
  }, []);

  const emoji = useMemo(() => {
    const currentTime = new Date().getHours();

    if (currentTime >= 5 && currentTime < 12) {
      return sunImg;
    }

    if (currentTime >= 12 && currentTime < 17) {
      return sunImg;
    }

    return waveImg;
  }, []);


  return (
    <div className="h-80 bg-yellow-200">
      <div className="container h-full flex justify-between py-8 relative overflow-hidden">
        <div
          className="absolute right-0 -translate-y-1/2 fingerprint-container"
        >
          <img
            src={fingerprintImg}
            alt="fingerprint background"
            className="w-full h-full object-cover"
          />
        </div>

        <div className="flex flex-col justify-end md:flex-row w-full relative">
          <div
            className="md:flex-1 md:self-end"
            style={{
              marginBottom: isMobileScreen ? 8 : 0
            }}
          >
            <img
              src={emoji}
              alt="fingerprint background"
              className="h-8"
            />

            <h1 className="font-poppins text-4xl font-semibold leading-12">{`${greeting}, ${profile?.full_name?.split(" ")?.[0]}`}</h1>
            <span className="font-poppins text-xs font-normal text-primary-black">{t("template.lastLogin")}</span>
          </div>
          <div className="md:self-end">
            <JobCreateButton
              text={t("button.create")}
              iconRight={<FiPlus size={18} />}
              dropdownOptions={[
                { label: t("button.create"), onClick: handleCreateJob },
                { label: t("button.browseTemplates"), to: "/jobs/template" }
              ]}
              color="primary"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  profile: state.profile.profileInfo,
  onboarding: state.dashboard?.onboarding,
  maximumJobs: getJobsMaximum(state)
});

export default connect(mapStateToProps)(EmptyStateHeader);
